module.exports = __webpack_public_path__ + "static/media/topCustomers.f8d00f13.mp4";